// Keep in sync with common\models\UserBots::TYPE_CHANNEL in www
const RESOURCE_TYPE_CHANNEL = 2;

// uuid of the system dashboard shown by default for channel resources
export const SYSTEM_DASHBOARD_UUID_CHANNEL = 'NMya4zhBImlBkQFOelVj3VBj_NOUNrXW';
// uuid of the system dashboard shown by default for bot resources
export const SYSTEM_DASHBOARD_UUID_BOT = 'oqxoTQjllpUn7EqKx5HLVQ0LyHAvRqSR';

export function getSystemDashboardIdForResource(resource) {
    return resource?.type === RESOURCE_TYPE_CHANNEL ? SYSTEM_DASHBOARD_UUID_CHANNEL : SYSTEM_DASHBOARD_UUID_BOT;
}

export function isSystemDefaultDashboardPath(path) {
    return path === `/dashboards/${SYSTEM_DASHBOARD_UUID_CHANNEL}` || path === `/dashboards/${SYSTEM_DASHBOARD_UUID_BOT}`;
}
